'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import SVG, { SVGProps } from '../svg'

// SVGs
// @ts-ignore
import LogomarkSVG from './logomark.react.svg'

/* -----------------------------------------------------------------------------
 * Logomark
 * -------------------------------------------------------------------------- */

export type LogomarkProps = Omit<SVGProps, 'svg'>

function Logomark(props: LogomarkProps) {
  return <SVG width={80} height={80} svg={LogomarkSVG} {...props} />
}

export default Logomark
